import ConfigView                   from 'scripts/defa/basic/view-config-view';
import SuccessView                  from 'scripts/defa/basic/view-success-view';
import SubscriptionPackages         from 'scripts/defa/subscription-packages/collection-subscription-packages';
import SubscriptionPackageContainer from 'scripts/defa/subscription-packages/view-subscription-package-container';
import Flow                         from 'scripts/poppet/flow';
import template                     from 'templates/subscriptionReplaceFlow.jst.html';

/**
 * defa.views.SubscriptionReplaceFlow
 * A flow to change subscription package on an existing subscription.
 * @version 1.2.0
 */

const channelLayout = Bb.Radio.channel( 'layout' );
const channel       = Bb.Radio.channel( 'objects' );

const selectors = {
	container: '[data-region=replace-container]',
};

const SubscriptionReplaceFlow = Flow.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	regions: {
		container: selectors.container,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView has selected a subscriptionPackage.
	 * @void
	 */
	onChildviewSubscriptionPackageSelected: function ( id ) {
		this.subscriptionPackage = channel.request( 'subscriptionPackages' ).get( id );
		this.dispatch();
	},
	
	/**
	 * Triggers when a successView asks to close up.
	 * @void
	 */
	onChildviewSuccessClose: function ( childView ) {
		childView.animateOut();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Dispaches the prepaid subscription flow.
	 * @void
	 */
	dispatch: function () {
		
		let fn = false;
		
		if ( !this.subscriptionPackages ) {
			fn = this._getSubscriptionPackages;
		}
		
		if ( this.subscriptionPackages && !this.subscriptionPackage ) {
			fn = this._showSelectSubscriptionPackages;
		}
		
		if ( this.subscriptionPackage && !this.subscriptionSaved ) {
			fn = this._saveSubscriptionPackage;
		}
		
		if ( this.subscriptionSaved ) {
			fn = this._showConfirmationView;
		}
		
		if ( _.isFunction( fn ) ) {
			fn.call( this );
		}
	},
	
	/**
	 * Fetches subscriptionpackages for the connected unit.
	 * @void
	 */
	_getSubscriptionPackages: function () {
		let self = this;
		
		// show waiting view
		let configView = new ConfigView( {
			context: 'wait',
		} );
		self.showChildView( 'container', configView );
		
		
		// create packages collection
		self.subscriptionPackages = new SubscriptionPackages();
		
		// attach error listener
		self.listenToOnce( self.subscriptionPackages, 'error', function ( collection, response ) {
			channelLayout.trigger( 'error', response.responseJSON );
		} );
		
		// attach sync listener
		self.listenToOnce( self.subscriptionPackages, 'sync', function () {
			
			// remove current package from the collection
			
			let arr = self.subscriptionPackages.reject( function ( model ) {
				return ( model.get( 'id' ) === self.model.get( 'transientPackageId' ) );
			} );
			
			self.subscriptionPackages = new SubscriptionPackages( arr );
			
			// return to dispatch
			self.stopListening( self.subscriptionPackages, 'error' );
			self.dispatch();
			
		} );
		
		
		// fetch the collection
		self.subscriptionPackages.fetch( {
			data       : {
				subscriptionId: self.options.subscriptionId,
				noAlarmGroup   : self.options.noAlarmGroup,
				
				//prepaid    : false,
				//unitId     : self.model.get( 'unit'  ),
				//customerId : self.model.get( 'owner' ),
			},
			processData: true,
		} );
	},
	
	/**
	 * Shows a view for selecting a new subscription package.
	 * @void
	 */
	_showSelectSubscriptionPackages: function () {
		let subscriptionPackageContainer = new SubscriptionPackageContainer( _.extend( {
			subscriptionPackage: channel.request( 'subscriptionPackages' ).get( this.model.get( 'transientPackageId' ) ),
			context            : 'replace',
			hidePromotion 	   : true,
			showCurrent        : true,
			owner              : this.model.get( 'owner' ),
			prepaid            : false,
			unit               : channel.request( 'units' ).get( this.model.get( 'unit' ) ),
			collection         : this.subscriptionPackages,
		}, this.options ) );
		
		this.showChildView( 'container', subscriptionPackageContainer );
	},
	
	/**
	 * Saves the new subscription package.
	 * @void
	 */
	_saveSubscriptionPackage: function () {
		this.listenToOnce( this.model, 'sync', function () {
			this.subscriptionSaved = true;
			this.dispatch();
		} );
		
		this.model.replacePackage( {
			subscriptionPackage: this.subscriptionPackage.get( 'id' ),
			promotionCode      : this.subscriptionPackage.get( 'promotionCode' ),
			noAlarmGroup        : this.options.noAlarmGroup,
			
		} );
		
	},
	
	/**
	 * Show a confirmation that the subscription has been changed.
	 * @void
	 */
	_showConfirmationView: function () {
		let successView = new SuccessView( {
			context: 'subscription:replaced',
		} );
		
		this.showChildView( 'container', successView );
	},
	
} );


export default SubscriptionReplaceFlow;